import './App.css';
import { useState, useEffect } from "react";
import Navbar from './Navbar.js';
import Login from './Login.js';
import Alerts from './Alerts';
import cover from './images/CoverZ.jpg';
import webicon from './images/website.png';
import arrow from './images/arrow.png';
import stamp from './images/CompleteStamp.png';
import Axios from "axios";
import axios from 'axios';

function App() {
  const [loading, setLoading] = useState(false)
  const [password, setPassword] = useState("")
  const [username, setUsername] = useState("")
  const [ActiveUser, setActiveUser] = useState("")
  const [ActiveULevel, setActiveULevel] = useState(0)
  const [ActiveData, setActiveData] = useState([])
  const [Adventures, setAdventures] = useState([])
  const [FocusAdventure, setFocusAdventure] = useState("0")
  const [Advtype, setAdvtype] = useState(false)
  const [ActiveDia, setActiveDia] = useState(0)
  const [DiaPass, setPassDia] = useState(false)
  const AdvInfo = require('./AdvInfo.js').AdvInfo
  const AdvLoc = require('./AdvInfo.js').AdvLoc
  const createUser = () => {
    if(username.length < 3){ 
      setActiveDia(3);
      setPassDia(true);
    } else if(password.length < 5) {
      setActiveDia(4);
      setPassDia(true);
    } else {
      axios.post("https://seattle-adv-cli.vercel.app/createuser", {username, password, level: '0', complete: []}).then((response) => {
        if(response.data === 'Username Already Exists'){
          setActiveDia(5);
          setPassDia(true);
        } else {setActiveDia(6); setPassDia(true);} 
      });
    }
  };
  const loginUser = () => {
    if(username.length < 3){ 
      setActiveDia(7);
      setPassDia(true);
    } else {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 6000);
      axios.post("https://seattle-adv-cli.vercel.app/loginuser", {username, password}).then((response) => {
      if(response.data){
        setActiveUser(username)
        Axios.post("https://seattle-adv-cli.vercel.app/getuserdata", {username}).then((response) => {
          setActiveData(response.data[0].complete);
          setActiveULevel(response.data[0].level);
        })
        Axios.get("https://seattle-adv-cli.vercel.app/getadventures").then((response) => {
          setAdventures(response.data);})
      } else {
        setActiveDia(1);
        setPassDia(true);
      }}).catch((e) => {setActiveDia(8); setPassDia(true);})
  }}
  const loginGuest = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 6000);
    setActiveUser("Guest");
    Axios.get("https://seattle-adv-cli.vercel.app/getadventures").then((response) => {setAdventures(response.data);})
  }
  const updateUser = () => {
    axios.post("https://seattle-adv-cli.vercel.app/updateuserdata", {username, password, ActiveULevel, ActiveData}).then((response) => {
      if(response.data){
        setActiveDia(2);
        setPassDia(true);
      } 
    }
  )};
  const logoutUser = () => {
    if(ActiveUser !== "Guest"){updateUser()};
    setActiveUser(undefined);
    setUsername(undefined);
  };
  const completeAdv = (advid) => {
    if(!ActiveData.includes(advid)){
      setActiveULevel(ActiveULevel + 1); 
      ActiveData.push(advid);
      setActiveDia(9);
      setPassDia(true);
    } else {
      alert("Adventure already Completed");
    }
  };
  const incompleteAdv = (advid) => {
    if(ActiveData.includes(advid)){
      setActiveULevel(ActiveULevel - 1); 
      ActiveData.splice(ActiveData.indexOf(advid), 1)
      setActiveDia(10);
      setPassDia(true);
    } else {
      alert("Adventure Not Completed");
    }
  };
  const handleClose = () => {
    setPassDia(false);
  };
  useEffect(() => {
    /*Axios.get("http://localhost:3001/getadventures").then((response) => {
      setAdventures(response.data);
    })*/
  }, [])

  function importAll(r) {
    return r.keys().map(r);
  }
  const images = importAll(require.context('./images', false, /\.(png|jpe?g|svg)$/));
  

let content
if(!ActiveUser){
  content = <div>
    <Login 
      loginUser = {loginUser}
      createUser = {createUser}
      loginGuest = {loginGuest}
      setUsername = {setUsername} 
      setPassword = {setPassword}/>
    </div>
} else {
if(FocusAdventure < 1){
content = <div className='acontent'>
          {loading && <div className="" style={{position: 'absolute', backgroundImage: `url(${cover})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', width: '100vw', height: '97.5vh', zIndex: '4'}}><img style={{border: 'solid black', borderRadius: "50%"}} src={images[3]} alt="logo" className='loadingani'></img></div>}
          <div className='maincontainer'>
            <div className="flex" style={{display: 'flex', justifyContent: "space-evenly"}}>
              <button autoFocus style={{backgroundColor: Advtype ? "rgb(226,225,201)" : "rgb(26, 142, 199)"}} className="mcsectionbuttons" onClick={(event) => {setAdvtype(false)}}>Next Adventures</button>
              <button style={{backgroundColor: !Advtype ? "rgb(226,225,201)" : "rgb(26, 142, 199)"}} className="mcsectionbuttons" onClick={(event) => {setAdvtype(true)}}>Completed Adventures</button>
            </div> 
            <div className='mcfeedcontainer'>
              <div className="adventuresdisplay">
                {ActiveULevel === 0 && Advtype && <div className='info1container'><p className='adventureinfo1'>No adventures have been completed yet.</p><p className='adventureinfo1'>Find your first adventure in the "Next Adventures" tab!</p></div>}
                {/*eslint-disable-next-line*/}
                {Adventures.map((adventure) => {
                  if(ActiveData.includes(adventure.advid) === Advtype){return (<div className='adventurecards' key={adventure.advid}>
                  <img style={{height: '100%', marginRight: '15px'}} src={images[adventure.advid + 3]} alt="logo" className=''></img>
                  <div style={{width: "100%", display: "flex", flexDirection: "column"}}>
                    <h3>{adventure.advname}</h3>
                    <div style={{display: 'flex', marginTop: "auto", marginBottom: "5px", transform: "translateX(-5px)"}}>
                      <p>~${adventure.advprice}</p>
                      <button style={{alignSelf: "flex-end", marginLeft: "auto", marginRight:"15px", padding: "0", width: "6.5em", height: "2em", fontSize: "clamp(14px, 1.5vw, 100px)"}} onClick={(event) => {setFocusAdventure(adventure.advid)}}> More Info</button>
                      <a href={adventure.advlinks} target="_blank" rel="noopener noreferrer" style={{marginRight: "5px"}}><img style={{height: 'clamp(35px, 3.25vw, 60px)', }} src={webicon} alt="website" className=''></img></a>
                    </div>
                  </div>
                </div>)}
                })}
              </div>
            </div>
          </div>
          </div>
} else {
content = <div className='acontent'>
          <div className='maincontainer' style={{backgroundColor: 'beige'}}>
            <div className='adventuresdisplay'>
              <button onClick={(event) => {setFocusAdventure(0)}} style={{paddingTop: "10px", paddingLeft: ".75vw",backgroundColor: 'transparent', border: 'none'}} ><img style={{height: 'clamp(40px, 3vw, 60px)', transform: 'scaleX(-1)', borderRadius: '50%'}} src={arrow} alt="website" className=''></img></button>
              <h1 className="Adv-header">{Adventures[FocusAdventure-1].advname}</h1>
            </div>
            <div style={{height: '65vh', display: 'flex', marginTop: "20px"}}>
              <div className="Adv-Content">
                <div className="Adv-Script">
                  <div style={{position: 'absolute', top: '-6px', left: '1.1vw', height: '40px', width: '40px', borderLeft: '2px solid black', borderTop: '2px solid black'}}></div>
                  <p>{AdvInfo[FocusAdventure]}</p>
                </div>
                <div style={{height: '20%', width: '100%', position: 'absolute', bottom: '10px'}}>
                  {ActiveData.includes(FocusAdventure) ? <button className="Adv-Buttoninc" onClick={(event) => {incompleteAdv(FocusAdventure)}}>Mark Incomplete</button> : <button className="Adv-Button" onClick={(event) => {completeAdv(FocusAdventure)}}>Complete Adventure</button>}
                  {ActiveData.includes(FocusAdventure) && <img style={{position: 'absolute', width: 'clamp(240px, 55%, 1000px)', mixBlendMode: 'multiply', bottom: '20px', transform: 'translateX(-20px)'}} src={stamp} alt="stamp" className=''></img>}
                </div>
              </div>
              <div className="Adv-View">
                <img style={{}} src={images[FocusAdventure+3]} alt="logo" className='Adv-Image'></img>
                <iframe src={AdvLoc[FocusAdventure]} className="Adv-Loc" loading="lazy" allowFullScreen="" referrerpolicy="no-referrer-when-downgrade" title="map"></iframe>
              </div>
            </div>
          </div>
          </div>
  }
}
  return (
    <div className="" style={{position: 'absolute',backgroundImage: `url(${cover})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', width: '100vw', height: '100vh'}}>
      <Navbar
        ActiveUser = {ActiveUser}
        ActiveULevel = {ActiveULevel}
        logoutUser = {logoutUser}/>
      {content}
      <Alerts 
        handleClose = {handleClose}
        ActiveDia = {ActiveDia}
        DiaPass = {DiaPass}/>
    </div>
  );
}

export default App;